import React from 'react';

/**
 * The small `?` that carries a metric's one-sentence definition.
 *
 * Extracted from the KPI card so that a metric explained on a card and the same metric explained in
 * a table header cannot drift into two different affordances. The definition is both the tooltip
 * and the accessible label, so it is available whether the reader hovers or uses a screen reader.
 *
 * It stops its own click: the surfaces it sits on — KPI cards, sortable table headers — are usually
 * interactive, and asking what a number means must never trigger the drill-down behind it.
 */
export function GovernanceMetricInfo({ info, className }: { info: string; className?: string }) {
  return (
    <span
      className={`inline-flex items-center justify-center w-4 h-4 rounded-full border border-slate-300 text-[10px] text-slate-400 cursor-help ${
        className || ''
      }`}
      title={info}
      aria-label={info}
      onClick={(event) => {
        event.stopPropagation();
      }}
    >
      ?
    </span>
  );
}
